import { View } from 'react-native';

import { Text, createMqStyles, tokens } from '@fhs/ui';
import Picture from '@fhs-legacy/frontend/src/components/picture';
import { CART_ITEM_LABEL } from '@fhs-legacy/frontend/src/utils/test-ids';
import { ICartEntry } from '@rbi-ctg/menu';

import ItemModifierList from './item-modifiers-list';

type ItemProfileProps = {
  item: ICartEntry;
  onEdit?: () => void;
};

export default function ItemProfile({ item, onEdit }: ItemProfileProps) {
  const mqStyles = useMqStyles();

  return (
    <View style={{ flexDirection: 'row', gap: 12, alignItems: 'flex-start' }}>
      <View style={mqStyles.imageContainer}>
        {item.image?.asset && (
          <Picture
            width="64px"
            height="56px"
            image={{
              __typename: 'Image',
              asset: { __typename: 'SanityImageAsset', ...item.image.asset },
            }}
            alt={`An image of a ${item.name}`}
            objectFitContain
          />
        )}
      </View>

      <View style={mqStyles.mainItemTitle}>
        <Text.Ui
          testID={CART_ITEM_LABEL}
          size="md"
          weight="semibold"
          numberOfLines={2}
          accessibilityRole="text"
          accessibilityLabel={item.name}
        >
          {item.name}
        </Text.Ui>
        <ItemModifierList modifiers={item.children} onEdit={onEdit} />
      </View>
    </View>
  );
}

const useMqStyles = createMqStyles({
  imageContainer: {
    $base: {
      borderRadius: 4,
      backgroundColor: tokens.colors.$blackOpacity04,
      width: 64,
      height: 56,
    },
  },
  mainItemTitle: {
    $base: {
      flex: 1,
    },
    $gteDesktop: { paddingTop: 8 },
    $ltDesktopLg: { paddingTop: 4 },
  },
});
